import React from "react";
import RegistrationContainer from "../components/Registration/RegistrationContainer";

type Props = {};

const Registration = (props: Props) => {
  return (
    <div className="page">
      <RegistrationContainer />
    </div>
  );
};

export default Registration;
